import { makeStyles, TableRow as MUITableRow } from "@material-ui/core";
import clsx from 'clsx';
import React from 'react';
import { styledBy } from '../../../../utils/styles';


const useStyle = makeStyles((theme) => ({
    root: {

        backgroundColor: styledBy('ascent', theme.palette.ascents)

    },
    selected: {
        "& .Mui-selected:hover": {
            backgroundColor: styledBy('ascent', theme.palette.ascents)
        }
    }

}))


const TableRow = ({ className, ascent = "white", ...props }) => {
    const classes = useStyle({ ascent })
    return (
        <MUITableRow {...props} className={clsx(classes.root, classes.selected, className)} />
    );
};

TableRow.propTypes = {

};

export default TableRow;